import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../../endpoint";
import type { HeroSection, HeroWord } from "../types";

export const getHero = async (): Promise<HeroSection> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.CMS.HERO.GET);
  return data.hero;
};

export const updateHero = async (
  payload: Pick<HeroSection, "headingLine1" | "headingLine2" | "paragraph">
): Promise<HeroSection> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.HERO.UPDATE, payload);
  return data.hero ?? data;
};

export const addHeroWord = async (payload: { word: string; displayOrder?: number }): Promise<HeroWord> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.CMS.HERO.ADD_WORD, payload);
  return data.word ?? data;
};

export const removeHeroWord = async (wordId: number): Promise<number> => {
  await privateClient.delete(SUPER_ADMIN_ENDPOINTS.CMS.HERO.REMOVE_WORD(wordId));
  return wordId;
};

export const reorderHeroWord = async (payload: { wordId: number; displayOrder: number }): Promise<{ wordId: number; displayOrder: number }> => {
  await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.HERO.REORDER_WORD(payload.wordId), {
    displayOrder: payload.displayOrder,
  });
  return payload;
};